var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23916 1.34164C4.47864 0.604591 5.52136 0.604592 5.76085 1.34164L6.39199 3.28409C6.49909 3.61371 6.80625 3.83688 7.15283 3.83688H9.19525C9.97023 3.83688 10.2924 4.82857 9.66548 5.28409L8.01313 6.4846C7.73274 6.68831 7.61541 7.04941 7.72251 7.37902L8.35365 9.32148C8.59313 10.0585 7.74955 10.6714 7.12258 10.2159L5.47023 9.0154C5.18984 8.81169 4.81016 8.81169 4.52977 9.0154L2.87742 10.2159C2.25045 10.6714 1.40687 10.0585 1.64635 9.32148L2.27749 7.37902C2.38459 7.04941 2.26726 6.68831 1.98687 6.4846L0.334522 5.28409C-0.292449 4.82857 0.029772 3.83688 0.804751 3.83688H2.84717C3.19375 3.83688 3.50091 3.61371 3.60801 3.28409L4.23916 1.34164Z",
    fill: "#02A750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStar);
export default __webpack_public_path__ + "static/media/GreenStar.3e7d5f7d05f6ea7034b24e578484d0db.svg";
export { ForwardRef as ReactComponent };